// extracted by mini-css-extract-plugin
export default {"root":"ReportLinks_root__aqqFL"};